import React, { useState, useEffect } from "react";
import "./index.scss";
import "./styles-v2.scss";
import { Tabs } from "./data";
import { getTournaments } from "../../services/tournaments";
import moment from "moment";
import { formatDate, omitNation, Arrow } from "../../helpers";
import { JT, WT, MT } from "../../helpers/constants/circuitCodes";

interface ModuleType {
  backgroundImage?: string;
  buttonColor?: string;
  buttonArrowColor?: string;
}

const TouramentTable = ({
  backgroundImage,
  buttonColor,
  buttonArrowColor = "fff"
}: ModuleType) => {
  const [tournaments, setTournaments] = useState({
    url: "",
    items: [
      {
        tournamentName: "",
        hostNation: "",
        category: "",
        hostNationCode: "",
        tournamentKey: "",
        isRecognised: "",
        liveLink: "",
        surfaceCode: "",
        surfaceDesc: "",
        indoorOrOutDoor: "",
        liveStreamingUrl: "",
        tournamentLink: ""
      }
    ],
    totalItems: 0
  });
  const [isLoading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState<number>(0);
  const ProTour = [WT, MT, JT].some(
    proCode => proCode === Tabs[activeTab].tourCode
  );
  const [startDate, endDate, tourCode] = [
    formatDate(
      ProTour
        ? moment()
            .startOf("week")
            .add(1, "day")
        : moment()
    ).raw,
    formatDate(
      ProTour
        ? moment()
            .endOf("week")
            .add(1, "day")
        : moment().add(1, "week")
    ).raw,
    Tabs[activeTab].tourCode
  ];

  useEffect(() => {
    setLoading(true);
    getTournaments({
      startDate,
      endDate,
      tourCode,
      take: 20,
      orderField:
        activeTab === getTabIndexByName("Masters") ? "tenniscategory" : ""
    }).then(res => {
      setTournaments(res);
      setLoading(false);
    });
  }, [activeTab]);

  const getTabIndexByName = (name: string) =>
    Tabs.findIndex(tab => tab.name === name);

  const tabsOnClickHandler = (index: number) => {
    setActiveTab(index);
  };

  const onButtonClickHandler = (index: number) => {
    setActiveTab(
      index > Tabs.length - 1 ? 0 : index == -1 ? Tabs.length - 1 : index
    );
  };

  const date =
    moment(startDate).month() === moment(endDate).month()
      ? `${moment(startDate).format("D")} -
  ${formatDate(endDate).longtNoComma}`
      : `${formatDate(startDate).longNoYear} -
  ${formatDate(endDate).longtNoComma}`;

  return (
    <div
      style={{
        backgroundImage: `url("${backgroundImage ? backgroundImage : ""}")`
      }}
      className="tournament-calendar curve"
    >
      <div className="container">
        <div className="tournament-calendar__container">
          <h4 className="tournament-calendar__heading--primary">
            This week's tournaments
          </h4>
          <h2 className="tournament-calendar__date">{date}</h2>
          <div
            className={`tournament-calendar__tabs-wrapper ${Tabs[activeTab].tourCode}`}
          >
            <div
              className={`tournament-calendar__tabs__tour-branding ${Tabs[activeTab].tourCode}`}
            ></div>
            <div className="tournament-calendar__tabs__navigation">
              <button
                onClick={() => {
                  setActiveTab(
                    activeTab == 0 ? Tabs.length - 1 : activeTab - 1
                  );
                }}
              >
                Previous
              </button>
              <button
                onClick={() => {
                  setActiveTab(activeTab < Tabs.length - 1 ? activeTab + 1 : 0);
                }}
              >
                Next
              </button>
            </div>
            <ul className="tournament-calendar__tabs">
              {Tabs.map((item, index) => (
                <li
                  className={`${item.class}${
                    index == activeTab ? " active" : ""
                  }`}
                  onClick={() => tabsOnClickHandler(index)}
                >
                  {item.name}
                </li>
              ))}
            </ul>
          </div>
          <div className="tournament-calendar__wrapper">
            <div
              className={`tournament-calendar__header ${Tabs[activeTab].tourCode}`}
            >
              <button
                style={{
                  backgroundColor: `#${buttonColor}`
                }}
                onClick={() => onButtonClickHandler(activeTab - 1)}
                className="tournament-calendar__btn--prev"
              >
                <Arrow fill={`#${buttonArrowColor}`} />
              </button>
              <h3>{Tabs[activeTab].title}</h3>
              <button
                style={{
                  backgroundColor: `#${buttonColor}`
                }}
                onClick={() => onButtonClickHandler(activeTab + 1)}
                className="tournament-calendar__btn--next"
              >
                <Arrow fill={`#${buttonArrowColor}`} />
              </button>
            </div>
            <div
              className={`tournament-calendar__table${
                isLoading ? " isLoading" : ""
              }`}
            >
              {tournaments.items.length ? (
                <table className="table">
                  <tbody>
                    {tournaments.items.map(event => (
                      <tr key={event.tournamentKey}>
                        <td className="tournament-name cell">
                          <a href={event.tournamentLink}>
                            <span>{event.tournamentName}</span>
                          </a>
                        </td>
                        <td className="location cell">
                          <div
                            className={`itf-flags itf-flags--${event.hostNationCode}`}
                          ></div>
                          <span className="location-name">
                            {omitNation(event.hostNation)}
                          </span>
                          <span className="location-name-code">
                            {omitNation(event.hostNationCode)}
                          </span>
                        </td>
                        <td className={`category cell`}>
                          <span className="category__environment">{`${
                            event.indoorOrOutDoor ? event.indoorOrOutDoor : ""
                          }`}</span>
                          {event.surfaceCode &&
                          event.indoorOrOutDoor !== null ? (
                            <span
                              className={`category__surface surface surface__${event.surfaceCode}`}
                            >
                              <div className="hide--mobile">
                                {` - ${event.surfaceDesc}`}
                              </div>
                            </span>
                          ) : null}
                        </td>
                        <td className="badges__container cell">
                          <div className="badges">
                            {event.isRecognised ? (
                              <div className="recognised-tournament"></div>
                            ) : null}
                            {event.liveStreamingUrl ? (
                              <a
                                className="watch-link-btn"
                                href={event.liveStreamingUrl}
                              >
                                Watch
                              </a>
                            ) : null}
                            {event.liveLink ? (
                              <a
                                className="live-link-btn"
                                href={event.liveLink}
                              >
                                Live
                              </a>
                            ) : null}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : isLoading ? null : (
                <p className="tournament-calendar__message">
                  There are no tournaments taking place this week
                </p>
              )}
            </div>
            <a
              href={tournaments.url}
              className="tournament-calendar__link-to-calendar"
            >
              {tournaments.totalItems ? (
                <span>View full calendar</span>
              ) : (
                <span>No results</span>
              )}
            </a>
          </div>
          <a
            href={tournaments.url}
            className="tournament-calendar__link-to-calendar"
          >
            {tournaments.totalItems ? (
              <span>View full calendar</span>
            ) : (
              <span>No results</span>
            )}
          </a>
        </div>
      </div>
    </div>
  );
};

export default TouramentTable;
